import { CreatedByUser } from '../../types/apps/apps.types';
import { FeatureName } from '../Feature/feature';

export const websiteFeatures = {
  forms: {
    id: 208,
    featureName: FeatureName.FORMS,
  },
  overview: {
    id: 209,
    featureName: FeatureName.OVERVIEW,
  },
} as const;
export const websiteFeaturesList = Object.entries(websiteFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const websiteModuleFeatures = [
  { moduleId: 44, featureId: websiteFeatures.forms.id },
  { moduleId: 44, featureId: websiteFeatures.overview.id },
];
